"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = require("../../utils/debounce");

var _ResponseItem = require("./ResponseItem.styled");

var _Icon = require("../Icon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UncheckedCheckBox = function UncheckedCheckBox(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }), _react.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

UncheckedCheckBox.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var CheckedCheckBox = function CheckedCheckBox(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), _react.default.createElement("path", {
    d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }));
};

CheckedCheckBox.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var ResponseItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ResponseItem, _PureComponent);

  function ResponseItem(props) {
    var _this;

    _classCallCheck(this, ResponseItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponseItem).call(this, props));

    _this.handleClick = function (e) {
      var disabled = _this.props.disabled;
      e.preventDefault();
      e.stopPropagation();

      if (!disabled) {
        _this.update();
      }
    };

    _this.update = (0, _debounce.throttle)(function () {
      var _this$props = _this.props,
          selected = _this$props.selected,
          selectOption = _this$props.selectOption,
          deselectOption = _this$props.deselectOption;

      if (!selected) {
        selectOption();
      } else {
        deselectOption();
      }
    }, 250);
    _this.state = {
      isSelected: props.selected
    };
    return _this;
  }

  _createClass(ResponseItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          className = _this$props2.className,
          text = _this$props2.text,
          selected = _this$props2.selected,
          checkboxColor = _this$props2.checkboxColor,
          numbering = _this$props2.numbering,
          isAnimated = _this$props2.isAnimated,
          children = _this$props2.children;
      return _react.default.createElement(_ResponseItem.StyledResponse, {
        id: id,
        className: className,
        selected: selected,
        isAnimated: isAnimated,
        tabIndex: "0",
        numbering: numbering,
        onClick: this.handleClick
      }, numbering && _react.default.createElement(_ResponseItem.StyledOptionIndex, {
        selected: selected
      }, numbering), _react.default.createElement(_ResponseItem.StyledOption, null, text), children || _react.default.createElement(_Icon.Icon, {
        width: "1.3rem",
        height: "1.3rem",
        color: checkboxColor
      }, selected && _react.default.createElement(CheckedCheckBox, null) || _react.default.createElement(UncheckedCheckBox, null)));
    }
  }]);

  return ResponseItem;
}(_react.PureComponent);
/**
 * Definition of default values for component props
 */


exports.ResponseItem = ResponseItem;
ResponseItem.defaultProps = {
  disabled: false,
  selected: false,
  numbering: null,
  isAnimated: true,
  checkboxColor: 'white',
  selectOption: function selectOption() {},
  deselectOption: function deselectOption() {},
  className: undefined,
  id: undefined,
  children: undefined
};
ResponseItem.propTypes = {
  text: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  numbering: _propTypes.default.string,
  isAnimated: _propTypes.default.bool,
  checkboxColor: _propTypes.default.string,
  selectOption: _propTypes.default.func,
  deselectOption: _propTypes.default.func,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  children: _propTypes.default.node
};